export default __webpack_public_path__ + "static/media/ad_970x90_install@2x.b5e48668.png";